export const TOKENS = {
  USDT: {
    MAINNET: {
      address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      decimals: 6,
    },
    TESTNET: {
      address: '0x4540BAEC9B0bB17Bc2023A9e11ea2813386fa3df',
      decimals: 18,
    }
  }
}

export const TRX_TOKENS = {
  USDT: {
    MAINNET: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
    TESTNET: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'
  }
}
